var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeButtonShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 26,
    viewBox: "0 0 161 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14209 18.0947L21.152 5.3584L33.8884 18.0947L44.7142 7.26885L55.5401 18.0947L66.366 7.26885L77.1918 18.0947L88.0177 7.26885L98.8436 18.0947L109.669 7.26885L120.495 18.0947L131.321 7.26885L142.147 18.0947L152.973 7.26885",
    stroke: "#E6EFFF",
    strokeWidth: 2.54726,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152.973,
    cy: 7.90546,
    r: 6.36816,
    fill: "#484EA1",
    stroke: "white",
    strokeWidth: 2.54726
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.77888,
    cy: 18.0949,
    r: 6.36816,
    fill: "#484EA1",
    stroke: "white",
    strokeWidth: 2.54726
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeButtonShape);
export default __webpack_public_path__ + "static/media/home-button-shape.36db0e3ae6fb9051b6fa1e0390e94055.svg";
export { ForwardRef as ReactComponent };